
import {
    Calendar, Callout, DatePicker, DateRangeType, DayOfWeek, DelayedRender,     
    IBasePicker, IBasePickerProps, ICalendarDayGridStyles, ICalendarDayProps, IconButton,
    IPersonaProps, IProcessedStyleSet, ITag, ITextStyles, ITooltipHostStyles, 
    mergeStyleSets, Text, TextField, Toggle, TooltipHost, TooltipOverflowMode, ValidationState
} from '@fluentui/react';
import moment from 'moment';
import React, { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { DayPickerStrings } from '../../shared/Utilities/calendar-IT';
import { IDateTimeField, IField, ILookupField, ITextField } from '../../shared/interfaces';
import AppUtilities from '../../shared/Utilities/appUtilities';
import { RootState } from '../../store';
import { useBoolean } from '@fluentui/react-hooks';
import { Indici_FormMode } from '../../shared/enums';
import { myTheme } from '../../assets/styles/my-theme';
import AutocompleteContact from './Inputs/AutocompleteContact';
import AutocompleteUser from './Inputs/AutocompleteUser';
import Autocomplete from './Inputs/Autocomplete';
import MyDropdown from './Inputs/MyDropdown';
import fieldsService from '../../services/fields.service';
import axios from 'axios';
import { toastRef } from '../Layout/Layout';
import ArxeiaLabel from './ArxeiaLabel';

const { palette } = myTheme;

const classNames = mergeStyleSets({
    inputWrapper:
    {
        paddingBottom: '20px',

    },
    callout: {
        padding: '8px',
    },
});

const calendarClassNames: IProcessedStyleSet<ICalendarDayGridStyles> = mergeStyleSets({
    dayCell: {
        backgroundColor: palette.neutralLight
    }

})

const tooltipHostStyles: Partial<ITooltipHostStyles> = {
    root: {
        display: 'inline-block',
        maxWidth: '100%',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'

    }
};

const textStyle: Partial<ITextStyles> = {
    root: {
        paddingLeft: 8,
        paddingRight: 8,
    }
};
export interface InputProps {
    formMode?: Indici_FormMode
    field: IField
    autofocus?: boolean,
    changed: (newField: IField) => void
}

const Input: React.FunctionComponent<InputProps> = props => {

    const [mostRecentlyUserUsed, setMostRecentlyUserUsed] = useState<any[]>([]);
    let [cleanDateButtonIsVisible, { setTrue: showDateClearButton, setFalse: hideDateClearButton }] = useBoolean(false);
    let [isCopyClipboardCalloutVisible, { setTrue: showCopyClipboardCalloutVisible, setFalse: hideCopyClipboardCalloutVisible }] = useBoolean(false);

    // variabili per range date
    const [selectedDateRange, setSelectedDateRange] = useState<Date[]>();
    const [selectedDate, setSelectedDate] = useState<Date>();
    const [isCalendarVisible, setIsCalendarVisible] = useState(false);

    const selectCurrentAoo = (state: RootState) => state.sessionReducer.currentAoo;
    const currentAoo = useSelector(selectCurrentAoo);

    const peoplePickerRef = React.createRef<IBasePicker<IPersonaProps>>();
    const tagPickerRef = React.createRef<IBasePicker<ITag>>();
    const divCalendarRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        if (props.autofocus)
            peoplePickerRef.current?.focusInput();
    }, [peoplePickerRef]);

    useEffect(() => {
        if (props.autofocus)
            tagPickerRef.current?.focusInput();
    }, [tagPickerRef]);

    //hook per chiusura calendario a click esterno
    useEffect(() => {
        function handleClickOutside(event) {
            if (divCalendarRef.current && !divCalendarRef.current.contains(event.target)) {
                setIsCalendarVisible(false);
            }
        }
        if (divCalendarRef.current) {
            const testElements = document.getElementById("searchFormPanel");
            testElements?.addEventListener("click", handleClickOutside)
        }
        return () => {
            document.removeEventListener("click", handleClickOutside);
        };
    }, [divCalendarRef]);

    useEffect(() => {
        if (props.field.controlType === "calendar" && (props.field as IDateTimeField).rangeMode) {
            hideDateClearButton();
        }
    }, [props.field])

    const inputChanged = (newField: IField) => {
        props.changed({ ...newField, valid: AppUtilities.checkFieldValidity(newField), touched: true })
    }

    const renderInputElementDiv = () => {

        switch (props.field.controlType) {
            case "calendar":
                let dateTimeField = props.field as IDateTimeField;
                let onCleanDateButton = () => {
                    inputChanged({ ...dateTimeField, internalValue: undefined });
                    setSelectedDateRange(undefined);
                    hideDateClearButton();
                }
                if (dateTimeField.internalValue && !cleanDateButtonIsVisible)
                    showDateClearButton();

                if (dateTimeField.rangeMode) {

                    const onCalendarTextFocus = () => {
                        setIsCalendarVisible(true);
                        if (dateTimeField.internalValue) {
                            setSelectedDateRange(dateTimeField.internalValue);
                            // con setSelectedDate evidenzio la data selezionata
                            setSelectedDate(dateTimeField.internalValue[dateTimeField.internalValue.length - 1]);
                        }

                    };

                    // metodi per creare range ed evidenziarlo
                    const handleDateClick = (date: Date) => {

                        // ricavo le date già selezionate
                        let newField = { ...dateTimeField } as IField;
                        let selectedValue = newField.internalValue !== undefined && newField.internalValue !== null ? [...newField.internalValue] : undefined;

                        // se non ci sono date selezionate, la prima data selezionata diventa la prima data del range
                        if (!selectedValue || selectedValue.length === 0) {
                            let rangeOfDates = [date];
                            inputChanged({ ...newField, internalValue: rangeOfDates });
                            setSelectedDate(date);
                            setSelectedDateRange(rangeOfDates);

                        }
                        // se c'è una data selezionata, la seconda data selezionata diventa la seconda data del range
                        else if (selectedValue && selectedValue.length === 1) {
                            selectedValue.push(date);
                            inputChanged({ ...newField, internalValue: selectedValue });
                            setSelectedDate(date);
                            setSelectedDateRange(selectedValue);
                            setIsCalendarVisible(false);

                        }
                        // se ci sono due date selezionate, la seconda data selezionata viene sostituita con la nuova data selezionata
                        else if (selectedValue && selectedValue.length === 2) {
                            selectedValue[1] = date;
                            inputChanged({ ...newField, internalValue: selectedValue });
                            setSelectedDate(date);
                            setSelectedDateRange(selectedValue);
                            setIsCalendarVisible(false);
                        }
                    }

                    // Props del component calendar che definiscono il render della cella del singolo giorno
                    // le usiamo per evidenziare il range di date selezionato
                    const calendarDayProps: Partial<ICalendarDayProps> = {
                        customDayCellRef: (element, date, classNames) => {
                            if (element && selectedDateRange) {
                                element.classList.remove(calendarClassNames.dayCell!);

                                // riordino le date per verificare se date si trova nel range definito in selectedDateRange
                                const sortedDates = [...selectedDateRange].sort((a, b) => {
                                    return a.getTime() - b.getTime();
                                });
                                var startDate = sortedDates[0];
                                var endDate = sortedDates[1];
                                if (date >= startDate && date <= endDate) {
                                    element.classList.add(calendarClassNames.dayCell!);
                                }
                            }
                            // se non ci sono date selezionate, rimuovo le classi che evidenziano il range
                            if (element && !dateTimeField.internalValue) {
                                element.classList.remove(calendarClassNames.dayCell!);
                                element.classList.remove(classNames.daySelected!);

                            }
                        }
                    }


                    return (
                        <div className={classNames.inputWrapper}>

                            <div className={props.field.touched && !props.field.valid ? 'field error' : 'field'}>

                                <ArxeiaLabel field={dateTimeField} />

                                <div ref={divCalendarRef} >
                                    <TextField
                                        placeholder="Selezionare una data o un range di date"
                                        onFocus={onCalendarTextFocus}
                                        value={AppUtilities.FormatDateRange(dateTimeField)}
                                        readOnly={true}
                                        onRenderSuffix={() => {
                                            if (cleanDateButtonIsVisible) {
                                                return <IconButton iconProps={{ iconName: 'Cancel' }} styles={{ root: { height: 30 } }} onClick={onCleanDateButton} />
                                            }
                                            else return null
                                        }}
                                        styles={{ suffix: { padding: "0px 1px 0px 4px", backgroundColor: "transparent" }, field: { paddingRight: "8px" } }}
                                    />
                                    {isCalendarVisible &&

                                        <Calendar
                                            value={selectedDate}
                                            firstDayOfWeek={DayOfWeek.Monday}
                                            strings={DayPickerStrings}
                                            onSelectDate={(date: Date) => {
                                                handleDateClick(date);
                                            }}
                                            showGoToToday
                                            highlightSelectedMonth
                                            dateRangeType={DateRangeType.Day}
                                            calendarDayProps={calendarDayProps}
                                        />
                                    }
                                </div>
                            </div>
                        </div>
                    );

                } else {

                    return (
                        <div className={classNames.inputWrapper}>

                            <div className={props.field.touched && !props.field.valid ? 'field error' : 'field'}>
                                <ArxeiaLabel field={dateTimeField} />

                                <DatePicker
                                    id={dateTimeField.internalName}
                                    key={dateTimeField.internalName}
                                    disabled={dateTimeField.readonly || dateTimeField.disabled}
                                    formatDate={onFormatDate}
                                    firstDayOfWeek={DayOfWeek.Monday}
                                    strings={DayPickerStrings}
                                    placeholder="Seleziona una data"
                                    ariaLabel="Seleziona una data"
                                    value={dateTimeField.internalValue}
                                    onSelectDate={(date) => {
                                        inputChanged({ ...dateTimeField, internalValue: date });
                                        showDateClearButton();
                                    }}

                                    textField={{
                                        onRenderSuffix: () => {
                                            if (cleanDateButtonIsVisible) {
                                                return <IconButton iconProps={{ iconName: 'Cancel' }} styles={{ root: { height: 30 } }} onClick={onCleanDateButton} />
                                            }
                                            else return null
                                        },
                                        styles: { suffix: { padding: "0px 1px 0px 4px", backgroundColor: "transparent" }, field: { paddingLeft: "40px", paddingRight: "8px" } }
                                    }}
                                    styles={{
                                        icon: { left: "4px", right: "unset" }
                                    }}
                                />
                                {props.field.touched && !props.field.valid && <span className="error-message">Campo obbligatorio</span>}

                            </div>
                        </div>

                    );
                }

            case "dropdown":
                return <MyDropdown {...props} />

            case "autocomplete":
                let lookupField: ILookupField = { ...props.field } as ILookupField;

                const searchTitolarioSuggestions = async (filterText: string, currentTags?: ITag[]): Promise<ITag[]> => {
                    let result: any[] = [];
                    if (currentAoo && filterText && filterText.length > 0) {
                        await fieldsService.getTitolarioSuggestion(currentAoo.id, filterText.toLowerCase())
                            .then(suggestions => {
                                result = [...suggestions];
                            })
                            .catch(error => {
                                if (axios.isCancel(error)) {
                                    //se non metto il catch partono delle chiamate tipo: static/js/vendors~main.chunk.js.map
                                    console.log(error.message);
                                } else if (!error.isErrorShown) {
                                    toastRef.current?.show({ severity: 'error', summary: 'Attezione', detail: `Impossibile leggere le informazioni`, life: 5000 });

                                }

                            });;
                        if (currentTags) {
                            //Rimuovo eventuali elementi già selezionati
                            result = result.filter(tag => currentTags.findIndex(el => el.key === tag.key) < 0);
                        }
                    }
                    return result;

                };

                if (props.field.internalName === "Titolario") {
                    lookupField.basePickerProps = { onResolveSuggestions: searchTitolarioSuggestions } as IBasePickerProps<ITag>;
                }
                return <Autocomplete {...props} field={{ ...lookupField }} />


            case "autocompleteUser":
                return <AutocompleteUser {...props} />

                //let userField = props.field as IUserField;
                //let userFieldBasePickerProps = userField.basePickerProps ? userField.basePickerProps as IBasePickerProps<IPersona> : undefined;

                //let selectedPersonas: any[] = [];
                //if (userField.internalValue)
                //    selectedPersonas = [...userField.internalValue];

                //const personaSuggestionProps: IBasePickerSuggestionsProps = userFieldBasePickerProps?.pickerSuggestionsProps ??
                //{
                //    suggestionsHeaderText: 'Suggerimenti',
                //    mostRecentlyUsedHeaderText: 'Utenti suggeriti',
                //    noResultsFoundText: 'Nessun risultato trovato',
                //    loadingText: 'Caricamento',
                //    showRemoveButtons: false,
                //    forceResolveText: "Cerca valore inserito",
                //    showForceResolve: props.formMode === Indici_FormMode.Search ? () => { return true } : () => { return false }
                //};


                //const onPeopelPickeFilterChanged = async (
                //    filterText: string,
                //    currentPersonas?: IPersonaProps[],
                //): Promise<IPersonaProps[]> => {
                //    if (filterText) {
                //        let filteredPersonas = await filterPersonasByText(filterText);

                //        if (currentPersonas)
                //            filteredPersonas = removePeoplePickerDuplicates(filteredPersonas, currentPersonas);

                //        return filteredPersonas;
                //    } else {
                //        return [];
                //    }
                //};

                //const filterPersonasByText = async (filterText: string): Promise<IPersonaProps[]> => {
                //    let personas: any[] = [];
                //    await usersService.getUserSuggestion(filterText)
                //        .then(suggestions => {
                //            suggestions.forEach(userField => {
                //                personas.push(
                //                    {

                //                        key: userField.userId,
                //                        imageUrl: userField.imageUrl,
                //                        imageInitials: userField.initials,
                //                        presence: userField.presence,
                //                        text: userField.displayName,
                //                        secondaryText: userField.userId,
                //                        showSecondaryText: true,
                //                        hidePersonaDetails: false,
                //                        user: userField

                //                    }
                //                );
                //            })
                //        });
                //    return personas;
                //};


                //const removePeoplePickerDuplicates = (personas: IPersonaProps[], possibleDupes: IPersonaProps[]) => {
                //    return personas.filter(persona => possibleDupes.findIndex(el => el.key === persona.key) < 0);
                //}

                //const onPersonaSelected = (selectedItem: any): IPersonaProps | null => {
                //    let recent = [...mostRecentlyUserUsed];
                //    recent.push({ selectedItem });
                //    //assegno l'operatore contains solo alle ricerche fatte aggiungendo un item custom 
                //    // e l'operatore equals alle ricerche fatte attraverso i suggerimenti
                //    let { search_QueryOperator } = userField;

                //    if (selectedItem.secondaryText === "GenericItem") {
                //        search_QueryOperator = Search_QueryOperator.Contains;
                //    } else {
                //        search_QueryOperator = Search_QueryOperator.Equals;
                //    }
                //    props.field.search_QueryOperator = search_QueryOperator;
                //    // restituendo null il component non aggiunge nessun elemento alla selezione e riesco a controllare
                //    // gli elementi selezionati tramite inputChanged(selectedItem) che setta l'internalValue del campo
                //    return selectedItem;
                //}
                //const onItemsChange = (items?: any[]): void => {
                //    inputChanged({ ...userField, internalValue: items });
                //};

                //const returnMostRecentlyUsed = (currentPersonas?: IPersonaProps[]) => {
                //    if (currentPersonas)
                //        return removePeoplePickerDuplicates(mostRecentlyUserUsed, currentPersonas);
                //    else
                //        return mostRecentlyUserUsed
                //};

                //const createGenericPeoplePickerItem = (input: string) => {
                //    let tag = { key: input, text: input, secondaryText: "GenericItem" }
                //    return tag;
                //}

                //return (
                //    <div className={classNames.inputWrapper}>
                //        <div className={userField.touched && !userField.valid ? 'field error' : 'field'}>
                //            <ArxeiaLabel field={userField} />
                //            <NormalPeoplePicker
                //                // eslint-disable-next-line react/jsx-no-bind
                //                onResolveSuggestions={onPeopelPickeFilterChanged}
                //                // eslint-disable-next-line react/jsx-no-bind
                //                // onEmptyInputFocus={returnMostRecentlyUsed}
                //                getTextFromItem={getTextFromPersonaItem}
                //                pickerSuggestionsProps={personaSuggestionProps}
                //                className={'ms-PeoplePicker'}
                //                key={'normal'}
                //                onValidateInput={validatePersonaInput}
                //                createGenericItem={createGenericPeoplePickerItem}
                //                selectionAriaLabel={'Selected contacts'}
                //                removeButtonAriaLabel={'Remove'}
                //                // inputProps={{
                //                //     onBlur: (ev: React.FocusEvent<HTMLInputElement>) => console.log('onBlur called'),
                //                //     onFocus: (ev: React.FocusEvent<HTMLInputElement>) => console.log('onFocus called'),
                //                //     'aria-label': 'People Picker',
                //                // }}
                //                onInputChange={onPeoplePickerInputChange}
                //                resolveDelay={300}
                //                disabled={userField.readonly || userField.disabled}
                //                onItemSelected={onPersonaSelected}
                //                selectedItems={selectedPersonas}
                //                itemLimit={userField.multi && props.formMode !== Indici_FormMode.Search ? undefined : 1}
                //                onChange={onItemsChange}
                //                componentRef={peoplePickerRef}

                //            />
                //            {userField.touched && !userField.valid && <span className="error-message">Campo obbligatorio</span>}

                //        </div>
                //    </div>
                //);

            case "autocompleteContact":
                return <AutocompleteContact {...props} />

            case "boolean":
                return (
                    <div className={classNames.inputWrapper}>
                        <ArxeiaLabel field={props.field} />
                        <Toggle
                            key={props.field.internalName}
                            disabled={props.field.readonly || props.field.disabled}
                            defaultChecked={props.field.internalValue}
                            onText="Sì"
                            offText="No"
                            onChange={(event, checked) => inputChanged({ ...props.field, internalValue: checked })}
                        />
                    </div>
                );

            case "textbox":
                let textField = props.field as ITextField;

                const onChangeTextFieldValue = (field: ITextField, newValue?: string) => {

                    let stringMaxLength = field.maxLength && field.maxLength > 0 && field.maxLength <= 255 ? field.maxLength : 255;

                    if (textField.sharepointType === "Number" || textField.sharepointType === "Currency") {
                        newValue = newValue?.replace(",", ".");
                        newValue = newValue?.replace(/[^0-9.-]/g, "");
                        if (newValue) {
                            // Regex per accettare numeri negativi e positivi con massimo 2 cifre decimali
                            const validNumberRegex = /^-?\d+(\.\d{0,2})?$/;

                            if (!validNumberRegex.test(newValue)) {
                                // Se il numero non è valido, tronca il numero a due cifre decimali:
                                const parts = newValue.split('.');
                                if (parts.length > 1) {
                                    newValue = parts[0] + '.' + parts[1].slice(0, 2);
                                } else {
                                    newValue = parts[0];
                                }
                            }
                        }
                    }
                    if (textField.toUpper) {
                        newValue = newValue?.toUpperCase();
                    }


                    if ((!newValue || newValue.length <= stringMaxLength)) {
                        inputChanged({ ...textField, internalValue: newValue });
                    }
                    else if (!field.internalValue || field.internalValue.toString().length < stringMaxLength) {
                        inputChanged({ ...textField, internalValue: newValue?.substring(0, stringMaxLength) });
                    }


                }

                return (
                    <div className={classNames.inputWrapper}>

                        <div className={textField.touched && !textField.valid ? 'field error' : 'field'}>
                            <ArxeiaLabel field={textField} />
                            <TextField
                                autoFocus={props.autofocus}
                                key={textField.internalName}
                                disabled={textField.readonly || textField.disabled}
                                value={textField.internalValue}
                                type={textField.type}
                                canRevealPassword={textField.canRevealPassword}
                                onChange={(event, newValue) => onChangeTextFieldValue(textField, newValue)}
                            />
                            {textField.touched && !textField.valid && <span className="error-message">Campo obbligatorio</span>}

                        </div>
                    </div>

                );

            case "textarea":
                return (
                    <div className={classNames.inputWrapper}>
                        <ArxeiaLabel field={props.field} />
                        <TextField
                            key={props.field.internalName}
                            disabled={props.field.readonly || props.field.disabled}
                            defaultValue={props.field.internalValue}
                            multiline
                            resizable={false}
                            errorMessage={props.field.touched && !props.field.valid ? 'Campo obbligatorio' : undefined}
                            onChange={(event, newValue) => inputChanged({ ...props.field, internalValue: newValue })}
                        />
                    </div>
                );
            default:
                <React.Fragment />
        }
    }
    const renderInputElementDivAsReadonly = () => {
        let field: IField = { ...props.field };
        let displayValue = AppUtilities.getDisplayValueFromFieldControlType(field);

        return (
            <div className={classNames.inputWrapper}>
                <ArxeiaLabel field={field} />
                <div className="flex flex-row align-items-center">

                    <TooltipHost
                        content={displayValue}
                        styles={tooltipHostStyles}
                        overflowMode={TooltipOverflowMode.Self}
                    >
                        {renderReadonlyElement(field, displayValue)}
                    </TooltipHost>

                    {props.field.showCopyButton && displayValue !== "-" &&
                        <IconButton id={props.field.internalName} iconProps={{ iconName: 'Copy' }} onClick={() => copyToClipboard(displayValue)} />
                    }
                    {props.field.showCopyButton && displayValue !== "-" &&
                        renderCopyClipboardCallout(props.field.internalName)
                    }

                </div>

            </div>
        );
    }

    const renderReadonlyElement = (field: IField, displayValue: string) => {


        switch (field.controlType) {
            //case "autocompleteContact":
            //    return <HoverCardContact field={field as IAutocompleteField} />

            case "calendar":
            case "dropdown":
            case "autocomplete":
            case "autocompleteUser":
            case "boolean":
            case "textbox":
            case "textarea":
            default:
                return <Text styles={textStyle}> {displayValue} </Text>


        }
    }
    const copyToClipboard = (value) => {
        navigator.clipboard.writeText(value);
        showCopyClipboardCalloutVisible();
        setTimeout(() => { hideCopyClipboardCalloutVisible(); }, 3000);

    }

    const renderCopyClipboardCallout = (buttonId) => {
        if (isCopyClipboardCalloutVisible) {
            return (
                <Callout className={classNames.callout} target={`#${buttonId}`} onDismiss={hideCopyClipboardCalloutVisible} role="alert">
                    <DelayedRender>
                        <Text variant="small">
                            Valore copiato negli appunti
                        </Text>
                    </DelayedRender>
                </Callout>
            )
        }
    }

    if (props.field.readonly) {
        return (
            <React.Fragment>
                {renderInputElementDivAsReadonly()}
            </React.Fragment>

        );

    }
    else {
        return (
            <React.Fragment>
                {renderInputElementDiv()}
            </React.Fragment>

        );

    }
};


export default Input;



const onFormatDate = (date?: Date): string => {
    moment.locale('it');
    var dateObjectd = moment(date)
    return dateObjectd.format('L');
};



/**
 * Takes in the picker input and modifies it in whichever way
 * the caller wants, i.e. parsing entries copied from Outlook (sample
 * input: "Aaron Reid <aaron>").
 *
 * @param input The text entered into the picker.
 */
function onPeoplePickerInputChange(input: string): string {
    const outlookRegEx = /<.*>/g;
    const emailAddress = outlookRegEx.exec(input);

    if (emailAddress && emailAddress[0]) {
        return emailAddress[0].substring(1, emailAddress[0].length - 1);
    }

    return input;
}

function getTextFromPersonaItem(persona: IPersonaProps): string {
    return persona.text as string;
}

function getTextFromTagItem(tag: ITag): string {
    return tag.name as string;
}

function validatePersonaInput(input: string): ValidationState {
    if (input.indexOf('@') !== -1) {
        return ValidationState.valid;
    } else if (input.length > 1) {
        return ValidationState.warning;
    } else {
        return ValidationState.invalid;
    }
}


